import { render, staticRenderFns } from "./ExemplaryPage.vue?vue&type=template&id=60723c6c&scoped=true"
import script from "./ExemplaryPage.vue?vue&type=script&lang=js"
export * from "./ExemplaryPage.vue?vue&type=script&lang=js"
import style0 from "./ExemplaryPage.vue?vue&type=style&index=0&id=60723c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60723c6c",
  null
  
)

export default component.exports